import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  topUpBalanceModal: {
    backgroundColor: 'unset',
    '& > div:first-child': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
    },
  },
  topUpBalanceModalPaper: {
    boxShadow: 'none',
    paddingTop: theme.spacing(24.5),
    maxWidth: theme.spacing(477),
    maxHeight: 'calc(100% - 4px)',
    width: '100%',
  },
  topUpBalanceModalContent: {
    padding: theme.spacing(15, 18.25, 49.5),
  },
  dialogContent: {
    borderRadius: theme.spacing(14),
    padding: 'unset!important'
  }
}));
